var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 101,
    viewBox: "0 0 74 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 47,
    width: 58,
    height: 8,
    rx: 3,
    fill: "#990000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38721 85.579C4.38721 83.9221 5.73035 82.5789 7.38721 82.5789H64.565C66.2219 82.5789 67.565 83.9221 67.565 85.5789V90.3275H4.38721V85.579Z",
    fill: "#990000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 96.2515C0 94.5946 1.34315 93.2515 3 93.2515H68.9525C70.6094 93.2515 71.9525 94.5946 71.9525 96.2515V101H0V96.2515Z",
    fill: "#990000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7749,
    y: 57.7252,
    width: 8.04348,
    height: 21.9298,
    rx: 3,
    fill: "#990000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2769,
    y: 57.7252,
    width: 8.04348,
    height: 21.9298,
    rx: 3,
    fill: "#990000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7788,
    y: 57.7252,
    width: 8.04348,
    height: 21.9298,
    rx: 3,
    fill: "#990000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.2808,
    y: 57.7252,
    width: 8.04346,
    height: 21.9298,
    rx: 3,
    fill: "#990000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7635 24.9217C21.6588 20.028 28.0223 17.1866 34.901 16.9515C35.4898 16.9314 36.0495 17.1954 36.4295 17.6457L39.4262 21.1962C39.6571 21.4697 39.9571 21.6763 40.2951 21.7943L45.1443 23.4881C45.5982 23.6467 45.9798 23.9634 46.2192 24.3803L47.8492 27.2187C48.0232 27.5218 48.1148 27.8652 48.1148 28.2147V32.1387C48.1148 32.6987 48.3497 33.2332 48.7622 33.6119L51.3361 35.975C51.5737 36.1931 51.8605 36.3505 52.1721 36.4338L57.4682 37.8498C57.8076 37.9405 58.1172 38.1191 58.3656 38.3675L61.5292 41.53C61.6045 41.6053 61.672 41.6881 61.7305 41.7771C62.4145 42.8178 61.6681 44.2018 60.4228 44.2018H36.0496L10.7749 44.2018C9.67033 44.2018 8.76726 43.3051 8.84819 42.2035C9.3258 35.7027 12.1217 29.562 16.7635 24.9217Z",
    fill: "#990000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8301 1.57431H49.7708C50.8754 1.57431 51.7708 2.46974 51.7708 3.57431V11.2702C51.7708 12.3748 50.8754 13.2702 49.7708 13.2702H35.8301V1.57431Z",
    fill: "#990000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8301 7.42224H49.7708C50.8754 7.42224 51.7708 8.31767 51.7708 9.42224V11.2702C51.7708 12.3748 50.8754 13.2702 49.7708 13.2702H35.8301V7.42224Z",
    fill: "#990000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6836 17.0819V1",
    stroke: "#990000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7295 19.9327L38.0239 16.7895C51.771 18.8362 56.402 10.9902 57.1089 6.55554C63.8947 22.8128 55.4758 30.4834 50.0891 32.3596V27.0234L47.2374 22.2719L40.7295 19.9327Z",
    fill: "#990000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3795 34.9181L51.6245 33.6024C59.7557 30.2105 61.7885 23.076 61.4961 17.9591C62.9829 17.9834 65.8512 18.1784 67.2727 16.2047C68.6942 14.231 70.2708 12.3304 74 12.2573C72.2207 12.9883 69.4225 16.9064 72.4644 26.731C74.8628 34.4503 67.5408 39.4259 63.6166 40.9123L58.9368 36.4532L53.3795 34.9181Z",
    fill: "#990000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSelected);
export default __webpack_public_path__ + "static/media/adminSelected.3147ac464a14db3af1b0912a8f8e8172.svg";
export { ForwardRef as ReactComponent };